var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-prog-bar",style:({
    left: (((1 / (_vm.steps.length * 2)) * 100) + "%"),
    'transition-duration': (_vm.transitionDuration + "ms"),
    width: ((_vm.width * 100) + "%")
  })})}
var staticRenderFns = []

export { render, staticRenderFns }